import React, { Component } from 'react';
import Modal from '../../../components/modals';
import { gql } from '@apollo/client';
import _ from 'lodash';
import '../../../../assets/scss/add-edit-popup.scss';
import { ReactComponent as RedCheckedIcon } from '../../../../assets/svg/red-checked.svg';
import { toast } from 'react-toastify';
import ProjectsGraphQl from '../../../../controllers/projectsGraphQl';

class ShowAssignEquipment extends ProjectsGraphQl {
	constructor() {
		super();
		this.state = {};
	}
	componentDidMount = () => {};
	handleCloseModal = () => {
		this.props.handleClose();
	};
	render() {
		return (
			<Modal
				handleClose={() => this.handleCloseModal()}
				show={this.props.show}
				modalType={'right-add'}
			>
				<div className="show-tenant-user-equipment-modal">
					<div className="project-add-edit-popup-header">
						<div className="header-title-container">
							<div className="title-container">
								<span className="title">Bhogesh Shrivastava</span>
							</div>
							<span className="sub-title">+91 9878767654</span>
						</div>
					</div>
					<div className="show-tenant-user-modal-body">
						<div className="individual-equip-card-container">
							<div className="card-header-container">
								<div className="header-left">
									<span>SH09 - Wedding</span>
									<span>PJ24 - Swatika and Gandhi</span>
								</div>
								<div className="header-right">
									<span>Love collective</span>
								</div>
							</div>
							<div className="card-table-container">
								<div className="table-header-container">
									<div className="table-header-th-1">QR CODE</div>
									<div className="table-header-th-2">DESCRIPTION</div>
									<div className="table-header-th-3">DAMAGE</div>
								</div>
								<div className="table-body-row-container">
									<div className="table-body-row-td-1">HDY01EQCC987876765432</div>
									<div className="table-body-row-td-2">Nikon 243234 sdgha</div>
									<div className="table-body-row-td-3">
										<span className="check-box-unchecked"></span>
									</div>
								</div>
								<div className="table-body-row-container">
									<div className="table-body-row-td-1">HDY01EQCC987876765432</div>
									<div className="table-body-row-td-2">Nikon 243234 sdgha</div>
									<div className="table-body-row-td-3">
										<span className="check-box-unchecked"></span>
									</div>
								</div>
								<div className="table-body-row-container">
									<div className="table-body-row-td-1">HDY01EQCC987876765432</div>
									<div className="table-body-row-td-2">Nikon 243234 sdgha</div>
									<div className="table-body-row-td-3">
										<span className="checked-icon">
											<RedCheckedIcon />
										</span>
									</div>
								</div>
								<div className="table-body-row-container">
									<div className="table-body-row-td-1">HDY01EQCC987876765432</div>
									<div className="table-body-row-td-2">Nikon 243234 sdgha</div>
									<div className="table-body-row-td-3">
										<span className="check-box-unchecked"></span>
									</div>
								</div>
								<div className="table-body-row-container">
									<div className="table-body-row-td-1">HDY01EQCC987876765432</div>
									<div className="table-body-row-td-2">Nikon 243234 sdgha</div>
									<div className="table-body-row-td-3">
										<span className="check-box-unchecked"></span>
									</div>
								</div>
							</div>
						</div>
						<div className="individual-equip-card-container">
							<div className="card-header-container">
								<div className="header-left">
									<span></span>
								</div>
								<div className="header-right">
									<span>Individual Equipment</span>
								</div>
							</div>
							<div className="card-table-container">
								<div className="table-header-container">
									<div className="table-header-th-1">QR CODE</div>
									<div className="table-header-th-2">DESCRIPTION</div>
									<div className="table-header-th-3">DAMAGE</div>
								</div>
								<div className="table-body-row-container">
									<div className="table-body-row-td-1">HDY01EQCC987876765432</div>
									<div className="table-body-row-td-2">Nikon 243234 sdgha</div>
									<div className="table-body-row-td-3">
										<span className="check-box-unchecked"></span>
									</div>
								</div>
								<div className="table-body-row-container">
									<div className="table-body-row-td-1">HDY01EQCC987876765432</div>
									<div className="table-body-row-td-2">Nikon 243234 sdgha</div>
									<div className="table-body-row-td-3">
										<span className="check-box-unchecked"></span>
									</div>
								</div>
								<div className="table-body-row-container">
									<div className="table-body-row-td-1">HDY01EQCC987876765432</div>
									<div className="table-body-row-td-2">Nikon 243234 sdgha</div>
									<div className="table-body-row-td-3">
										<span className="checked-icon">
											<RedCheckedIcon />
										</span>
									</div>
								</div>
								<div className="table-body-row-container">
									<div className="table-body-row-td-1">HDY01EQCC987876765432</div>
									<div className="table-body-row-td-2">Nikon 243234 sdgha</div>
									<div className="table-body-row-td-3">
										<span className="check-box-unchecked"></span>
									</div>
								</div>
								<div className="table-body-row-container">
									<div className="table-body-row-td-1">HDY01EQCC987876765432</div>
									<div className="table-body-row-td-2">Nikon 243234 sdgha</div>
									<div className="table-body-row-td-3">
										<span className="check-box-unchecked"></span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</Modal>
		);
	}
}

export default ShowAssignEquipment;
